




































































import { Component, Mixins, Watch, } from "vue-property-decorator";
import { ElTree } from "element-ui/types/tree";
import { DialogMixin } from "../../../system/mixins";
import { IFixedPhraseReferenceTreeData, } from "../../../../domain/document";
import { FixedPhraseImportDialogMixin } from "./mixins";

@Component
export default class FixedPhraseImportDialog extends Mixins(DialogMixin, FixedPhraseImportDialogMixin) {
  $refs!: {
    tree: ElTree<string, IFixedPhraseReferenceTreeData>,
    fileSelector: HTMLInputElement,
  };

  get isImportable(): boolean {
    return this.nodes && this.nodes.length > 0 && this.areNodesChecked;
  }

  async show(): Promise<IFixedPhraseReferenceTreeData[]> {
    return this.showModal(async () => {
      await this.waitHidden();
      return this.isConfirmed
        ? this.getCheckedNodes()
        : null;
    });
  }

  importFixedPhrases(): void {
    this.isConfirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isConfirmed = false;
    this.isVisible = false;
  }

  fileSelected(e: Event): void {
    const target = e.target as HTMLInputElement;
    if (target.files.length < 1) {
      this.selectedFile = null;
      return;
    }
    const file = target.files[0];
    if (!file) {
      this.selectedFile = null;
      return;
    }
    this.selectedFile = file;
  }

  getCheckedNodes(): IFixedPhraseReferenceTreeData[] {
    if (!this.$refs.tree) { return null; }
    return this.$refs.tree.getCheckedNodes();
  }

  onCheckChanged(): void {
    const checkedNodes = this.getCheckedNodes();
    this.areNodesChecked = (checkedNodes && checkedNodes.length > 0);
  }

  @Watch("selectedFile")
  onSelectedFileChanged(newValue: File): void {
    try {
      if (this.$refs.fileSelector && !newValue) {
        this.$refs.fileSelector.value = "";
        return;
      }

      this.isLoading = true;
      this.selectedFixedPhrase = "";
      this.nodes = [];
      this.areNodesChecked = false;
      const csvExtensionRegEx = /\.csv$/i;
      if (csvExtensionRegEx.test(newValue.name)) {
        this.readCsvFile(newValue);
      } else {
        this.readJsonFile(newValue);
      }
    } catch (e) {
      this.$error("読み込み失敗", "ファイルの読み込みに失敗しました。", e);
    } finally {
      this.isLoading = false;
    }
  }
}
